import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { PageHeader } from "@/components/shared";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { ChangePassword } from "@/components/ChangePassword";

const FIELDS = [
  ["confirmations", "Confirmations requises (défaut)", "number"],
  ["order_ttl_minutes", "Durée de validité d'une commande (min)", "number"],
  ["late_payment_hours", "Surveillance paiement tardif après expiration (h)", "number"],
  ["fee_percent", "Frais de service (%) — informatif", "number"],
  ["blockchain_source", "Source blockchain", "text"],
];

export default function AdminSettings() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/settings").then((r) => setS(r.data)); }, []);
  const save = async (e) => {
    e.preventDefault();
    try { const { data } = await api.put("/admin/settings", { ...s, confirmations: Number(s.confirmations), order_ttl_minutes: Number(s.order_ttl_minutes), late_payment_hours: Number(s.late_payment_hours), fee_percent: Number(s.fee_percent) }); setS(data); toast.success("Réglages globaux enregistrés"); }
    catch (e2) { toast.error(errMsg(e2)); }
  };
  if (!s) return null;
  return (
    <div>
      <PageHeader title="Réglages globaux" subtitle="Valeurs par défaut appliquées aux marchands qui n'ont pas défini les leurs." />
      <form onSubmit={save} className="panel p-5 grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-3xl">
        {FIELDS.map(([k, label, type]) => (
          <div key={k} className="space-y-1.5"><Label>{label}</Label><Input type={type} value={s[k] ?? ""} onChange={(e) => setS({ ...s, [k]: e.target.value })} data-testid={`admin-setting-${k}`} /></div>
        ))}
        <div className="sm:col-span-2"><Button type="submit" className="bg-amber-500 hover:bg-amber-400 text-zinc-950 font-semibold" data-testid="admin-settings-save-btn">Enregistrer</Button></div>
      </form>
      <div className="max-w-3xl mt-8"><ChangePassword /></div>
    </div>
  );
}
